import { http } from './config/config-get-ip'
export default {
    getIp: async () => {
        return http.get()
    }
}